import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

const AdminRoute = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has ADMIN role
  const isAdmin = user?.roles?.includes("ADMIN");

  // Redirect to dashboard if not admin
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render admin content
  return children;
};

export default AdminRoute;
